export const en = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    remove: 'Remove',
    download: 'Download',
    print: 'Print',
    preview: 'Preview',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    home: 'Home',
    about: 'About',
    ageCalculator: 'Age Calculator',
    dateDifference: 'Date Difference',
    tafqit: 'Tafqit',
    quickWhats: 'Quick WhatsApp',
    qrGenerator: 'QR Generator',
    resume: 'Resume',
    greetingCards: 'Greeting Cards',
    email: 'Email',
    serviceCodeTitle: 'Enter Service Code',
    serviceCodeSubtitle: 'Enter 3 digits for quick service access',
    goToService: 'Go to Service',
    serviceCodeExamples: 'Service code examples:',
    invalidCode: '000',
    todayDate: 'Today\'s Date',
    hijriCalendar: 'Hijri Calendar',
    gregorianCalendar: 'Gregorian Calendar',
    currentTime: 'Current Time',
    timezone: 'Timezone',
    copyDate: 'Copy Date',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    footerCopyright: 'Made with ❤️ in 🇸🇦',
    widgetSectionTitle: 'Free Services & Tools',
    widgetSectionSubtitle: 'Diverse and easy-to-use tools programmed with',
    cards: [
      {
        title: 'Age Calculator',
        description: 'Calculate your age in Gregorian and Hijri calendars with extra info'
      },
      {
        title: 'Date Difference Calculator',
        description: 'Calculate the difference between any two dates in Gregorian and Hijri'
      },
      {
        title: 'Tafqit (Numbers to Text)',
        description: 'Convert numbers to written text.'
      },
      {
        title: 'Quick WhatsApp',
        description: 'Send quick messages to any Android device.'
      },
      {
        title: 'QR Code Generator',
        description: 'Create QR codes the easiest way.'
      },
      {
        title: 'Smart Resume',
        description: 'Create a smart resume the easiest way.'
      },
      {
        title: 'Greeting Cards',
        description: 'Create greeting cards the easiest way'
      },
      {
        title: 'Adhkar',
        description: 'Morning and evening adhkar and more'
      },
      {
        title: 'Saudi Dates',
        description: 'Time remaining for important dates in the Kingdom'
      },
      {
        title: 'Data Analyzer',
        description: 'Analyze data and convert JSON/CSV to auto-generated code'
      },
      {
        title: 'More',
        description: 'Explore more services and tools'
      }
    ]
  },
  about: {
    title: 'Osama Al-Zubaidi',
    subtitle: 'Data Analyst, Web Developer, and Mathematics Specialist',
    description: 'I can turn numbers into laughter and code into coffee!',
    tagline: 'Creating Scalable, Dynamic, and Responsive Web Solutions',
    technicalSkillsTitle: 'Technical Skills',
    workExperienceTitle: 'Work Experience',
    projectsTitle: 'My Projects',
    contact: 'Start Your Project!',
    contactDescription: 'Let\'s build something great together',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    send: 'Send',
    technicalSkills: {
      html: 'HTML',
      css: 'CSS',
      scss: 'SCSS',
      tailwind: 'Tailwind CSS',
      javascript: 'JavaScript',
      node: 'Node.js',
      angular: 'Angular',
      react: 'React',
      github: 'GitHub',
      gitbash: 'Git Bash',
      php: 'PHP',
      java: 'Java',
      springboot: 'Spring Boot',
      express: 'Express.js',
      mongodb: 'MongoDB',
      postgresql: 'PostgreSQL',
      python: 'Python',
      typescript: 'TypeScript',
      remix: 'Remix',
      mysql: 'MySQL',
      docker: 'Docker',
      aws: 'AWS',
      firebase: 'Firebase'
    },
    workExperience: {
      current: 'Full Time Job',
      internship: 'Intern',
      freelance: 'Freelance',
      location: 'Location',
      responsibilities: 'Responsibilities'
    },
    projects: {
      viewLive: 'Live',
      viewCode: 'Code',
      technologies: 'Technologies'
    }
  },
  tabs: {
    education: 'Education',
    experience: 'Experience',
    skills: 'Skills',
    basic: 'Basic Information',
    summary: 'Summary',
    layout: 'Layout'
  },
  education: {
    add: 'Add Education',
    remove: 'Remove Education',
    institution: 'Institution',
    location: 'Location',
    degree: 'Degree',
    field: 'Field of Study',
    date: 'Date',
    gpa: 'GPA',
    achievements: 'Academic Achievements',
    reorder: 'Reorder',
    showInResume: 'Show in Resume',
    hideFromResume: 'Hide from Resume',
    qualification: 'qualification',
    qualifications: 'qualifications'
  },
  experience: {
    add: 'Add Experience',
    remove: 'Remove Experience',
    position: 'Position',
    company: 'Company',
    location: 'Location',
    start: 'Start Date',
    end: 'End Date',
    responsibilities: 'Responsibilities',
    reorder: 'Reorder',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    saveState: 'Save State',
    restoreState: 'Restore State',
    copyExperience: 'Copy Experience',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    experience: 'experience',
    experiences: 'experiences'
  },
  skills: {
    addCategory: 'Add Skill Category',
    removeCategory: 'Remove Skill Category',
    addSkill: 'Add Skill',
    removeSkill: 'Remove Skill',
    categoryName: 'Skill Category',
    skill: 'Skill',
    reorder: 'Reorder',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    saveState: 'Save State',
    restoreState: 'Restore State',
    copyCategory: 'Copy Category',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    category: 'category',
    categories: 'categories'
  },
  resume: {
    basicInfo: {
      title: 'Basic Information',
      name: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      location: 'Location',
      website: 'Website',
      linkedin: 'LinkedIn',
    },
    summary: {
      title: 'Professional Summary',
      placeholder: 'Write a brief summary of your professional background and key strengths...',
    },
    experience: {
      title: 'Work Experience',
      add: 'Add Experience',
      position: 'Position',
      company: 'Company',
      location: 'Location',
      startDate: 'Start Date',
      endDate: 'End Date',
      present: 'Present',
      responsibilities: 'Responsibilities',
      addResponsibility: 'Add Responsibility',
    },
    education: {
      title: 'Education',
      add: 'Add Education',
      institution: 'Institution',
      degree: 'Degree',
      field: 'Field of Study',
      location: 'Location',
      startDate: 'Start Date',
      endDate: 'End Date',
      present: 'Present',
      gpa: 'GPA',
      description: 'Description',
    },
    skills: {
      title: 'Skills',
      add: 'Add Skill',
      name: 'Skill Name',
      level: 'Proficiency Level',
      levels: {
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        expert: 'Expert',
      },
    },
  },
  layout: {
    title: 'Layout',
    fontSize: 'Font Size',
    lineHeight: 'Line Height',
    marginV: 'Vertical Margin',
    marginH: 'Horizontal Margin',
    color: 'Color',
    align: 'Text Direction',
    rtl: 'Arabic',
    ltr: 'English',
    template: 'Template',
    selectTemplate: 'Select a template',
  },
  templates: {
    professional: {
      name: 'Professional',
      description: 'Clean and professional design optimized for ATS systems',
    },
    classic: {
      name: 'Classic Two-Column',
      description: 'Traditional layout with personal characteristics',
    },
    minimal: {
      name: 'Minimal',
      description: 'Straightforward design for maximum ATS compatibility',
    },
    timeline: {
      name: 'Timeline',
      description: 'Chronological layout emphasizing experience progression',
    },
    modern: {
      name: 'Modern',
      description: 'Contemporary design with strong ATS compatibility',
    },
  },
  navigation: {
    basicInfo: 'Basic Info',
    summary: 'Summary',
    experience: 'Experience',
    education: 'Education',
    skills: 'Skills',
    layout: 'Layout',
    preview: 'Preview',
  },
  errors: {
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    invalidPhone: 'Invalid phone number',
    invalidDate: 'Invalid date',
    invalidGPA: 'GPA must be between 0 and 4.0',
  },
  messages: {
    saveSuccess: 'Resume saved successfully',
    saveError: 'Error saving resume',
    deleteConfirm: 'Are you sure you want to delete this item?',
    unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
  },
  dataAnalytics: {
    title: 'Smart Data Analyzer',
    subtitle: 'Analyze data and convert JSON/CSV to auto-generated code',
    description: 'Advanced tool for data analysis and code generation in multiple programming languages',
    
    // Data Upload
    upload: {
      title: 'Upload Data',
      subtitle: 'Drag and drop JSON or CSV files, or copy and paste data',
      dragDrop: 'Drag and drop files here',
      or: 'or',
      browse: 'Browse Files',
      paste: 'Copy and Paste Data',
      supportedFormats: 'Supported formats: JSON, CSV',
      maxSize: 'Max size: 10MB',
      clear: 'Clear Data',
      demo: 'Use Demo Data'
    },
    
    // Data Analysis
    analysis: {
      title: 'Data Analysis',
      subtitle: 'Automatically discover data structure and types',
      analyzing: 'Analyzing data...',
      error: 'Error analyzing data',
      success: 'Data analyzed successfully',
      
      // Statistics
      stats: {
        title: 'Statistics',
        totalRecords: 'Total Records',
        totalFields: 'Total Fields',
        uniqueFields: 'Unique Fields',
        enumFields: 'Enum Fields',
        idFields: 'ID Fields',
        requiredFields: 'Required Fields',
        nullableFields: 'Nullable Fields'
      },
      
      // Fields
      fields: {
        title: 'Field Analysis',
        name: 'Field Name',
        type: 'Type',
        nullable: 'Nullable',
        unique: 'Unique',
        required: 'Required',
        examples: 'Examples',
        statistics: 'Statistics',
        suggestions: 'Suggestions'
      }
    },
    
    // Code Generation
    output: {
      title: 'Code Generation',
      subtitle: 'Choose your programming language',
      copy: 'Copy',
      copied: 'Copied',
      download: 'Download',
      languages: {
        typescript: 'TypeScript',
        python: 'Python',
        sql: 'SQL',
        go: 'Go',
        java: 'Java',
        csharp: 'C#',
        php: 'PHP',
        rust: 'Rust',
        swift: 'Swift',
        kotlin: 'Kotlin',
        zod: 'Zod',
        pydantic: 'Pydantic',
        django: 'Django',
        fastapi: 'FastAPI',
        sqlalchemy: 'SQLAlchemy',
        mongoose: 'Mongoose',
        prisma: 'Prisma',
        sequelize: 'Sequelize',
        typeorm: 'TypeORM',
        jsonSchema: 'JSON Schema',
        openapi: 'OpenAPI',
        protobuf: 'Protocol Buffers',
        graphql: 'GraphQL'
      }
    },
    
    // Data Visualization
    visualization: {
      title: 'Data Visualization',
      subtitle: 'Discover patterns and relationships in your data through interactive charts',
      generating: 'Generating charts...',
      summary: 'Quick Summary',
      charts: 'Charts',
      insights: 'Discovered Insights',
      recommendations: 'Recommendations',
      dataPoints: 'Data Points',
      chart: 'Chart',
      type: 'Type',
      labels: 'Labels'
    },
    
    // Features
    features: {
      title: 'Advanced Features',
      items: [
        {
          icon: '🔍',
          title: 'Smart Analysis',
          description: 'Automatic detection of data types and relationships'
        },
        {
          icon: '📊',
          title: 'Advanced Statistics',
          description: 'Comprehensive data analysis with percentiles'
        },
        {
          icon: '🎯',
          title: 'Code Generation',
          description: 'Support for 20+ programming languages and frameworks'
        },
        {
          icon: '📈',
          title: 'Visualizations',
          description: 'Interactive data visualization'
        },
        {
          icon: '🔧',
          title: 'Auto Optimizations',
          description: 'Suggestions for data structure improvements'
        },
        {
          icon: '⚡',
          title: 'High Performance',
          description: 'Fast processing of large datasets'
        }
      ]
    },
    
    // Examples
    examples: {
      title: 'Data Examples',
      items: [
        {
          name: 'User Data',
          description: 'Example of user data with personal information',
          data: JSON.stringify([
            { id: 1, name: 'John Doe', email: 'john@example.com', age: 25, city: 'New York', isActive: true },
            { id: 2, name: 'Jane Smith', email: 'jane@example.com', age: 30, city: 'Los Angeles', isActive: false },
            { id: 3, name: 'Bob Johnson', email: 'bob@example.com', age: 28, city: 'Chicago', isActive: true }
          ], null, 2)
        },
        {
          name: 'Product Data',
          description: 'Example of product data with prices and categories',
          data: JSON.stringify([
            { id: 1, name: 'Laptop', price: 999.99, category: 'Electronics', stock: 15, rating: 4.5 },
            { id: 2, name: 'Smartphone', price: 599.99, category: 'Electronics', stock: 8, rating: 4.2 },
            { id: 3, name: 'Programming Book', price: 29.99, category: 'Books', stock: 50, rating: 4.8 }
          ], null, 2)
        },
        {
          name: 'Sales Data',
          description: 'Example of sales data with dates and amounts',
          data: JSON.stringify([
            { id: 1, date: '2024-01-15', amount: 1500.00, customer: 'Tech Corp', product: 'Software' },
            { id: 2, date: '2024-01-16', amount: 2300.50, customer: 'Law Office', product: 'Consulting' },
            { id: 3, date: '2024-01-17', amount: 800.25, customer: 'Restaurant', product: 'Food' }
          ], null, 2)
        },
        {
          name: 'CSV Data',
          description: 'Example of CSV data for employees',
          data: `name,age,department,salary,join_date
John Doe,25,Development,5000,2023-01-15
Jane Smith,30,Marketing,4500,2022-06-20
Bob Johnson,28,Sales,4800,2023-03-10
Alice Brown,32,HR,4200,2021-12-05`
        }
      ]
    },
    
    // Actions
    actions: {
      copy: 'Copy',
      copied: 'Copied',
      download: 'Download',
      clear: 'Clear',
      analyze: 'Analyze',
      generate: 'Generate',
      visualize: 'Visualize',
      export: 'Export',
      import: 'Import',
      save: 'Save',
      load: 'Load',
      reset: 'Reset',
      help: 'Help',
      settings: 'Settings'
    },
    
    // Advanced Dashboard
    dashboard: {
      title: 'Advanced Dashboard',
      subtitle: 'Comprehensive data view with charts and metrics',
      show: 'Show Dashboard',
      hide: 'Hide Dashboard',
      share: 'Share Dashboard',
      export: 'Export Configuration',
      metrics: 'Metrics',
      charts: 'Charts',
      filters: 'Filters',
      refresh: 'Refresh',
      autoRefresh: 'Auto Refresh',
      viewMode: 'View Mode',
      grid: 'Grid',
      list: 'List',
      expand: 'Expand',
      compress: 'Compress',
      hideChart: 'Hide Chart',
      showChart: 'Show Chart',
      loading: 'Loading...',
      noData: 'No data available',
      noCharts: 'No charts available',
      totalRecords: 'Total Records',
      totalColumns: 'Total Columns',
      numericColumns: 'Numeric Columns',
      categoricalColumns: 'Categorical Columns',
      dateColumns: 'Date Columns',
      dataCompleteness: 'Data Completeness',
      missingData: 'Missing Data',
      uniqueValues: 'Unique Values',
      correlations: 'Correlations',
      trends: 'Trends',
      insights: 'Insights',
      recommendations: 'Recommendations',
      availableFilters: 'Available Filters',
      selectFilter: 'Select Filter',
      applyFilters: 'Apply Filters',
      clearFilters: 'Clear Filters',
      filterBy: 'Filter By',
      dateRange: 'Date Range',
      selectDate: 'Select Date',
      selectValues: 'Select Values',
      enterValue: 'Enter Value',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      chartControls: 'Chart Controls',
      exportChart: 'Export Chart',
      shareChart: 'Share Chart',
      fullscreen: 'Fullscreen',
      exitFullscreen: 'Exit Fullscreen',
      dashboardConfig: 'Dashboard Configuration',
      saveConfig: 'Save Configuration',
      loadConfig: 'Load Configuration',
      resetConfig: 'Reset Configuration',
      customizeTheme: 'Customize Theme',
      lightTheme: 'Light Theme',
      darkTheme: 'Dark Theme',
      autoTheme: 'Auto Theme',
      purpleTheme: 'Purple Theme',
      blueTheme: 'Blue Theme',
      greenTheme: 'Green Theme'
    }
  }
}; 